<script lang="ts" setup>
import type { DashboardScoreDiagnosticTask } from '@/core/domain/dashboard/DashboardScoreDiagnosticTask.ts'
import { computed } from 'vue'

import PTag from 'primevue/tag'
import { EvaluationRange } from '@/core/domain/resources/enums/EvaluationRange.ts'
import { QuizType } from '@/core/domain/resources/enums/QuizType.ts'

const props = defineProps<{
  taskResult: DashboardScoreDiagnosticTask
  type: QuizType.Values
}>()

const results = computed(() => {
  return {
    percentage:
      props.type === 'DIAG_END'
        ? props.taskResult.diagEndScorePercentRounded
        : props.taskResult.diagScorePercentRounded,
    evalRangeName:
      props.type === 'DIAG_END'
        ? props.taskResult.diagEndEvalRangeName
        : props.taskResult.diagEvalRangeName
  }
})
</script>

<template>
  <div class="flex items-center gap-2">
    <p class="w-10 font-bold">
      <template v-if="results.percentage != null"> {{ results.percentage }}% </template>

      <template v-else> - </template>
    </p>
    <p-tag
      v-if="results.evalRangeName"
      :class="{
        'bg-green-300 text-green-900': results.evalRangeName === EvaluationRange.Values.FORCE,
        'bg-yellow-300 text-yellow-900':
          results.evalRangeName === EvaluationRange.Values.EFFORT_A_FAIRE,
        'bg-red-300 text-red-900': results.evalRangeName === EvaluationRange.Values.DEFI
      }"
    >
      {{ EvaluationRange.label(results.evalRangeName) }}
    </p-tag>
  </div>
</template>
